(function () {
  var SELECTOR = '[data-mystic-parallax-media]';
  var sections = new Set();
  var ticking = false;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileQuery = window.matchMedia('(max-width: 1023px)');

  function isEnabled(section) {
    if (reduceMotion.matches) return false;

    var isMobile = mobileQuery.matches;
    var desktopEnabled = section.getAttribute('data-parallax-desktop') === 'true';
    var mobileEnabled = section.getAttribute('data-parallax-mobile') === 'true';

    return isMobile ? mobileEnabled : desktopEnabled;
  }

  function reset(section) {
    section.style.removeProperty('--mystic-media-parallax-y');
  }

  function update(section) {
    if (!isEnabled(section)) {
      reset(section);
      return;
    }

    var rect = section.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var strength = parseFloat(section.getAttribute('data-parallax-strength')) || 18;
    var centerOffset = rect.top + rect.height / 2 - viewportHeight / 2;
    var progress = centerOffset / Math.max(viewportHeight, 1);
    var y = Math.max(-strength, Math.min(strength, progress * strength * -2));

    section.style.setProperty('--mystic-media-parallax-y', y.toFixed(2) + 'px');
  }

  function updateAll() {
    ticking = false;
    sections.forEach(update);
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateAll);
  }

  function collect() {
    sections.clear();
    document.querySelectorAll(SELECTOR).forEach(function (section) {
      sections.add(section);
      update(section);
    });
  }

  document.addEventListener('DOMContentLoaded', collect);
  document.addEventListener('shopify:section:load', collect);
  document.addEventListener('shopify:section:unload', collect);
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', requestUpdate);
  if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', requestUpdate);
})();
